var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 91,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9100",
    d: "M22.575 87.933a36.046 36.046 0 0 0 12.212 2.58 35.889 35.889 0 0 0 16.358-3.298 50.977 50.977 0 0 1-15.948-10.013 27.285 27.285 0 0 1-12.622 10.731Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC400",
    d: "M35.2 77.205c-10.505-9.714-16.878-23.776-16.339-39.2.018-.499.045-1 .075-1.5a27.229 27.229 0 0 0-14.206.147A35.879 35.879 0 0 0 .022 53.235c-.544 15.58 8.884 29.191 22.553 34.697A27.269 27.269 0 0 0 35.2 77.205Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9100",
    d: "M35.2 77.205a27.041 27.041 0 0 0 4.096-13.428c.453-12.985-8.277-24.156-20.36-27.273-.03.5-.057 1.002-.075 1.502-.536 15.42 5.834 29.482 16.339 39.199Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD2C00",
    d: "M37.944 0c-6.88 5.513-12.317 12.781-15.603 21.155a50.839 50.839 0 0 0-3.41 15.35c12.082 3.117 20.812 14.287 20.357 27.275a27.083 27.083 0 0 1-4.096 13.427A50.86 50.86 0 0 0 51.14 87.22c11.951-5.523 20.43-17.41 20.92-31.469.317-9.11-3.182-17.228-8.126-24.081C58.71 24.424 37.944 0 37.944 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.5d8fdc39d2967ce05e3596e3e2d96b8a.svg";
export { ForwardRef as ReactComponent };